import { BrowserRouter, Routes, Route } from "react-router-dom"
import Layout from "./components/layout/Layout";
import Sidebar from "./components/sidebar/Sidebar";
import WebsiteSetting from "./features/setting/websites/WebsiteSetting";
import WebsiteFeeExclusionPage from "./features/setting/websites/WebsiteFeeExclusionPage";
import WarehouseReceivingAddressSetting from "./features/setting/warehouseReceivingAddress/WarehouseReceivingAddressSetting";
import DefaultOrderSetting from "./features/setting/defaultProfile/DefaultProfileSetting";
import KeyData from "./features/keyData/KeyData";
import CustomerProfile from "./features/customerProfile/CustomerProfile";
import Login from "./features/user/Login";
import CollectMoney from "./features/collectMoney/CollectMoney";
import AddTracking from "./features/addTracking/AddTracking";
import OrderSummary from "./features/customer/orderSummary/OrderSummary";
import ShipDateSetting from "./features/setting/shipDate/ShipDateSetting";
import React, { useEffect } from "react";
import WeeklyShipImport from "./features/weeklyShip/WeeklyShipImport";
import WeeklyShip from "./features/weeklyShip/WeeklyShip";
import SendOnlyForm from "./features/customer/sendOnly/SendOnlyForm";
import WeeklyShipMatch from "./features/weeklyShip/WeeklyShipMatch";
import WeeklyShipUnpackMatch from "./features/weeklyShip/WeeklyShipUnpackMatch";
import WeeklyShipBoxInsert from "./features/weeklyShip/WeeklyShipBoxInsert";
import WeeklyShipBoxWeightInsert from "./features/weeklyShip/WeeklyShipBoxWeightInsert";
import WeeklyShipAction from "./features/weeklyShip/WeeklyShipAction";
import ExchangeMoney from "./features/money/exchangeMoney/ExchangeMoney";
import TravelCardSetting from "./features/setting/travelCard/TravelCardSetting";
import WithdrawRecord from "./features/money/withdrawRecord/WithdrawRecord";
import TrackingMatch from "./features/weeklyShip/TrackingMatch";
import BankSetting from "./features/setting/bank/BankSetting";
import ReceiptIssue from "./features/receiptIssue/ReceiptIssue";
import ReportSelectionPage from "./features/report/ReportSelectionPage";
import ExpenseRecord from "./features/money/expense/ExpenseRecord";
import ExpenseOptionSetting from "./features/setting/expenseOption/ExpenseOptionSetting";
import AdminSetting from "./features/setting/admin/AdminSetting";
import KpiListSetting from "./features/setting/kpiList/KpiListSetting";
import TierConfigSetting from "./features/setting/tierConfig/TierConfigSetting";
import CouponSetting from "./features/setting/coupon/CouponSetting";
import AgreementTypeSetting from "./features/setting/agreementType/AgreementTypeSetting";
import OrderByOptionSetting from "./features/setting/orderByOption/OrderByOptionSetting";
import OrderRoutingRulesSetting from "./features/setting/orderRoutingRules/OrderRoutingRulesSetting";
import MercariRoutingSettingsSetting from "./features/setting/mercariRoutingSettings/MercariRoutingSettingsSetting";
import DispatchSetting from "./features/setting/dispatch/DispatchSetting";
import DispatchBuyerPage from "./features/setting/dispatch/DispatchBuyerPage";
import DispatchProofPage from "./features/setting/dispatch/DispatchProofPage";
import DispatchTrackingPage from "./features/setting/dispatch/DispatchTrackingPage";
import MerpayUrgencyExplorerSetting from "./features/setting/merpayUrgencyExplorer/MerpayUrgencyExplorerSetting";
import AdminKpiRecord from "./features/admin/kpiRecord/AdminKpiRecord";
import AdminKpiRecordView from "./features/admin/kpiRecord/AdminKpiRecordView";
import AdminKpiListView from "./features/admin/kpiRecord/AdminKpiListView";
import AdminKpiSummaryGenerate from "./features/admin/kpiRecord/AdminKpiSummaryGenerate";
import SalaryPayment from "./features/admin/kpiRecord/SalaryPayment";
import AnnualTaxDocuments from "./features/admin/annualTax/AnnualTaxDocuments";
import AdminOvertime from "./features/admin/overtime/AdminOvertime";
import CategoryReport from "./features/admin/categoryReport/CategoryReport";
import PollerHealth from "./features/admin/pollerHealth/PollerHealth";
import TransferBackfill from "./features/admin/transferBackfill/TransferBackfill";
import AdminLeave from "./features/admin/leave/AdminLeave";
import AdminMistakeRecord from "./features/admin/adminMistake/AdminMistakeRecord";
import AdminSpecialTaskRecord from "./features/admin/specialTask/AdminSpecialTaskRecord";
import Register from "./features/user/Register";
import axios from 'axios';
import ProtectedRoute from "./routes/ProtectedRoute";
import ActivityTracker from "./components/ActivityTracker";
import PublicRoute from "./routes/PublicRoute";
import ForgotPassword from "./features/user/ForgotPassword";
import Order from "./features/order/Order";
import './globalStyles.css';
import Arrival from "./features/weeklyShip/Arrival";
import PlatformArrival from "./features/weeklyShip/PlatformArrival";
import NoDeliveryFee from "./features/order/NoDeliveryFee";
import CollectMoneyPerson from "./features/collectMoney/CollectMoneyPerson";
import BillProcess from "./features/order/BillProcess";
import ArrivalAccept from "./features/order/ArrivalAccept";
import Blacklist from "./features/customerProfile/Blacklist";
import OverSizeList from "./features/overSize/OverSizeList";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  BarController,
  LineController,
  LineElement,
  PointElement,
  Title,
  Tooltip,
  Legend
} from 'chart.js';
import VipCustomerList from "./features/customerProfile/VipCustomerList";
import UserProfile from "./features/user/UserProfile";
import SkuSetting from "./features/company/sku/SkuSetting";
import CollectMoneyOldNotPaid from "./features/collectMoney/CollectMoneyOldNotPaid";
import AddStock from "./features/company/stock/AddStock";
import CompanyOrder from "./features/company/order/CompanyOrder";
import Crm from "./features/customerProfile/Crm";
import NewProfileOrder from "./features/customerProfile/NewProfileOrder";
import { fetchTodayRate } from './redux/features/todayRateSlice';
import { useDispatch } from "react-redux";
import { setShop } from './redux/features/shopSlice';
import { useAuth } from './context/AuthContext';
import StockBalance from "./features/company/stock/StockBalance";
import MercariAuctionManager from "./features/mercari/MercariAuctionManager";
import MercariChange from "./features/mercari/MercariChange";
import MercariAdmin from "./features/mercari/mercariAdminDashboard.js/MercariAdmin";
import DispatchReport from "./features/mercari/dispatchReport/DispatchReport";
import MercariVerifyQueue from "./features/mercari/MercariVerifyQueue";
import MercariNotApprovedList from "./features/mercari/MercariNotApprovedList";
import HandCarryList from "./features/handCarry/HandCarryList";
import HandCarryTypeAssignment from "./features/handCarry/HandCarryTypeAssignment";
import OrderSummaryAdmin from "./features/order/OrderSummaryAdmin";
import OrdersWithoutConfirmImage from "./features/keyData/OrdersWithoutConfirmImage";
import ReceiveMercari from "./features/order/ReceiveMercari";
import CheckMercari from "./features/order/CheckMercari";
import PurchaseImageList from "./features/keyData/PurchaseImageList";
import PendingBeamBeforePurchases from "./features/order/PendingBeamBeforePurchases";
import LabelGenerator from "./features/label/LabelGenerator";
import MonthlyExport from "./features/company/export/MonthlyExport";
import WhtCertificatePage from "./features/company/whtCertificate/WhtCertificatePage";
import MonthlyUnpaid from "./features/company/monthlyUnpaid/MonthlyUnpaid";
import YearStartUnshippedBeamReport from "./features/company/accounting/YearStartUnshippedBeamReport";
import DividendDashboard from "./features/report/DividendDashboard";
import AirItemTypeSetting from "./features/setting/airItemType/AirItemTypeSetting";
import BrandSetting from "./features/setting/brand/BrandSetting";
import WeightPriceListSetting from "./features/setting/weightPriceList/WeightPriceListSetting";
import LandingScheduleSetting from "./features/setting/landingSchedule/LandingScheduleSetting";
import WeeklyShipShipmentGroupSummary from "./features/weeklyShip/WeeklyShipShipmentGroupSummary";
import WeeklyShipIshipImport from "./features/weeklyShip/WeeklyShipIshipImport";
import WeeklyShipAirDetail from "./features/weeklyShip/WeeklyShipAirDetail";
import WeeklyShipAirManage from "./features/weeklyShip/WeeklyShipAirManage";
import WeeklyShipAirSummary from "./features/weeklyShip/WeeklyShipAirSummary";
import CompositeJob from "./features/weeklyShip/CompositeJob";
import HighValueOrders from "./features/weeklyShip/HighValueOrders";
import IsAirUrlSetting from "./features/backoffice/isAirUrl/IsAirUrlSetting";
import PaymentSummaryQueue from "./features/backoffice/paymentSummaryQueue/PaymentSummaryQueue";
import BeamWebhookReplay from "./features/backoffice/beamWebhookReplay/BeamWebhookReplay";
import FindParcel from "./features/backoffice/findParcel/FindParcel";
import PendingOrdererConfirms from "./features/backoffice/pendingOrdererConfirms/PendingOrdererConfirms";
import { LiffApp, ShopDomainRedirect } from "./features/liff";
import LiffSubmissions from "./features/liff/admin/LiffSubmissions";
import ManualUpload from "./features/util/manualUpload/ManualUpload";
import TrackingLookup from "./features/util/trackingLookup/TrackingLookup";
import ScanLog from "./features/util/scanLog/ScanLog";
import DebtFollowUp from "./features/debtFollowUp/DebtFollowUp";
import CustomerCompanyInfoPage from "./features/customerProfile/CustomerCompanyInfoPage";
import AnnouncementList from "./features/admin/announcement/AnnouncementList";
import AnnouncementCreate from "./features/admin/announcement/AnnouncementCreate";
import ChatFeedbackInbox from "./features/chatFeedback/ChatFeedbackInbox";
import ChatFeedbackImport from "./features/chatFeedback/ChatFeedbackImport";
import ChatFeedbackDashboard from "./features/chatFeedback/ChatFeedbackDashboard";
import RefundTransfer from "./features/money/refundTransfer/RefundTransfer";
import RefundReceiptPage from "./features/money/refundTransfer/RefundReceiptPage";
import VoidCheckPage from "./features/money/refundTransfer/VoidCheckPage";
import CaseTicket from "./features/caseTicket/CaseTicket";
import CaseTicketDetail from "./features/caseTicket/CaseTicketDetail";

// Register the components needed for the chart
ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  BarController,
  LineController,
  LineElement,
  PointElement,
  Title,
  Tooltip,
  Legend
);


axios.defaults.withCredentials = true;
// Tag every request as the admin console so the backend uses the admin_token cookie,
// keeping this session separate from a customer-app session in the same browser.
axios.defaults.headers.common['X-App'] = 'admin';

const routes = [
  { path: "/login", component: Login },
  { path: "/register", component: Register },
  { path: "/", component: Sidebar }, 
  { path: "/collectmoney", component: CollectMoney },
  { path: "/collectmoneyperson", component: CollectMoneyPerson },
  { path: "/collectold", component: CollectMoneyOldNotPaid },
  { path: "/ordersummary", component: OrderSummary },
  { path: "/admin/ordersummary/", component: OrderSummary },
  { path: "/admin/ordersummaryadmin/", component: OrderSummaryAdmin },
  { path: "/sendonly", component: SendOnlyForm },
  { path: "/checkarrival", component: ArrivalAccept },
  { path: "/admin/sendonly", component: SendOnlyForm },
  { path: "/addtracking", component: AddTracking },
  { path: "/setting/default-order", component: DefaultOrderSetting },
  { path: "/setting/shipdate", component: ShipDateSetting },
  { path: "/setting/landing-schedule", component: LandingScheduleSetting },
  { path: "/setting/travelcard", component: TravelCardSetting },
  { path: "/setting/website", component: WebsiteSetting },
  { path: "/setting/website-fee-exclusion", component: WebsiteFeeExclusionPage },
  { path: "/setting/warehouse-receiving-address", component: WarehouseReceivingAddressSetting },
  { path: "/setting/bank", component: BankSetting },
  { path: "/setting/expense", component: ExpenseOptionSetting },
  { path: "/setting/admin", component: AdminSetting },
  { path: "/setting/kpi-list", component: KpiListSetting },
  { path: "/setting/tier-config", component: TierConfigSetting },
  { path: "/setting/coupon", component: CouponSetting },
  { path: "/setting/agreement", component: AgreementTypeSetting },
  { path: "/setting/order-by", component: OrderByOptionSetting },
  { path: "/setting/order-routing-rules", component: OrderRoutingRulesSetting },
  { path: "/setting/mercari-routing-settings", component: MercariRoutingSettingsSetting },
  { path: "/setting/dispatch", component: DispatchSetting },
  { path: "/setting/merpay-urgency", component: MerpayUrgencyExplorerSetting },
  { path: "/admin/kpi-record", component: AdminKpiRecord },
  { path: "/admin/kpi-view", component: AdminKpiRecordView },
  { path: "/admin/kpi-list-view", component: AdminKpiListView },
  { path: "/admin/overtime", component: AdminOvertime },
  { path: "/admin/leave", component: AdminLeave },
  { path: "/admin/admin-mistake", component: AdminMistakeRecord },
  { path: "/admin/special-task", component: AdminSpecialTaskRecord },
  { path: "/admin/kpi-summary-generate", component: AdminKpiSummaryGenerate },
  { path: "/admin/salary-payment", component: SalaryPayment },
  { path: "/admin/annual-tax-documents", component: AnnualTaxDocuments },
  { path: "/admin/category-report", component: CategoryReport },
  { path: "/admin/poller-health", component: PollerHealth },
  { path: "/admin/transfer-backfill", component: TransferBackfill },
  { path: "/setting/airitemtype", component: AirItemTypeSetting },
  { path: "/setting/brand", component: BrandSetting },
  { path: "/order/weightpricelist", component: WeightPriceListSetting },
  { path: "/customer-profile", component: CustomerProfile },
  { path: "/customer-company-info", component: CustomerCompanyInfoPage },
  { path: "/blacklist", component: Blacklist },
  { path: "/vipcustomerlist", component: VipCustomerList },
  { path: "/keydata", component: KeyData },
  { path: "/weeklyship/import", component: WeeklyShipImport },
  { path: "/weeklyship", component: WeeklyShip },
  { path: "/weeklyship/arrival", component: Arrival },
  { path: "/weeklyship/platform-arrival", component: PlatformArrival },
  { path: "/weeklyship/match", component: WeeklyShipMatch },
  { path: "/weeklyship/unpack-match", component: WeeklyShipUnpackMatch },
  { path: "/weeklyship/boxinsert", component: WeeklyShipBoxInsert },
  { path: "/weeklyship/boxweightinsert", component: WeeklyShipBoxWeightInsert },
  { path: "/weeklyship/action", component: WeeklyShipAction },
  { path: "/weeklyship/composite", component: CompositeJob },
  { path: "/exchangemoney", component: ExchangeMoney },
  { path: "/refund", component: RefundTransfer },
  { path: "/case-ticket", component: CaseTicket },
  { path: "/case-ticket/:id", component: CaseTicketDetail },
  { path: "/withdrawrecord", component: WithdrawRecord },
  { path: "/expenserecord", component: ExpenseRecord },
  { path: "/weeklyship/tracking", component: TrackingMatch },
  { path: "/receiptissue", component: ReceiptIssue },
  { path: "/report", component: ReportSelectionPage },
  { path: "/order", component: Order },
  { path: "/bill", component: BillProcess },
  { path: "/ordernodelivery", component: NoDeliveryFee },
  { path: "/userprofile", component: UserProfile },
  { path: "/company/sku", component: SkuSetting },
  { path: "/company/stock/add", component: AddStock },
  { path: "/company/order/", component: CompanyOrder },
  { path: "/company/stock/balance", component: StockBalance },
  { path: "/company/monthly-export", component: MonthlyExport },
  { path: "/company/wht-certificate", component: WhtCertificatePage },
  { path: "/company/monthly-unpaid", component: MonthlyUnpaid },
  { path: "/company/accounting/year-start-unshipped-beam", component: YearStartUnshippedBeamReport },
  { path: "/report/dividend", component: DividendDashboard },
  { path: "/crm/", component: Crm },
  { path: "/newprofileorder/", component: NewProfileOrder },
  { path: "/mercari", component: MercariAuctionManager },
  { path: "/mercarichange", component: MercariChange },
  { path: "/mercariadmin", component: MercariAdmin },
  { path: "/mercari-buyer-report", component: DispatchReport },
  { path: "/mercari-verify", component: MercariVerifyQueue },
  { path: "/mercari-verify-rejected", component: MercariNotApprovedList },
  { path: "/handcarry", component: HandCarryList },
  { path: "/handcarry-type-assignment", component: HandCarryTypeAssignment },
  { path: "/noconfirmimage", component: OrdersWithoutConfirmImage },
  { path: "/receive-mercari", component: ReceiveMercari },
  { path: "/check-mercari", component: CheckMercari },
  { path: "/purchase-image-list", component: PurchaseImageList },
  { path: "/oversize", component: OverSizeList }, 
  { path: "/neworder", component: PendingBeamBeforePurchases },
  { path: "/label-generator", component: LabelGenerator },
  { path: "/weeklyship/shipment-group-summary", component: WeeklyShipShipmentGroupSummary },
  { path: "/weeklyship/iship-import", component: WeeklyShipIshipImport },
  { path: "/weeklyship/air-detail", component: WeeklyShipAirDetail },
  { path: "/weeklyship/air-manage", component: WeeklyShipAirManage },
  { path: "/weeklyship/air-summary", component: WeeklyShipAirSummary },
  { path: "/weeklyship/high-value", component: HighValueOrders },
  { path: "/backoffice/isairurl", component: IsAirUrlSetting },
  { path: "/backoffice/payment-summary-queue", component: PaymentSummaryQueue },
  { path: "/backoffice/beam-webhook-replay", component: BeamWebhookReplay },
  { path: "/backoffice/find-parcel", component: FindParcel },
  { path: "/backoffice/pending-orderer-confirms", component: PendingOrdererConfirms },
  { path: "/liff-submissions", component: LiffSubmissions },
  { path: "/util/manual-upload", component: ManualUpload },
  { path: "/util/tracking-lookup", component: TrackingLookup },
  { path: "/util/scan-log", component: ScanLog },
  { path: "/debt-follow-up", component: DebtFollowUp },
  { path: "/notifications", component: AnnouncementList },
  { path: "/admin/announcement/create", component: AnnouncementCreate },
  { path: "/chat-feedback", component: ChatFeedbackInbox },
  { path: "/chat-feedback/import", component: ChatFeedbackImport },
  { path: "/chat-feedback/dashboard", component: ChatFeedbackDashboard },
];

function App() {

  const dispatch = useDispatch();
  const { authState } = useAuth();
  const { isAuthenticated } = authState;

  useEffect(() => {
    const initializeShop = async () => {
      const storedShopName = localStorage.getItem('shopName');
      if (!storedShopName) {
        try {
            const response = await axios.get('/api/user/getshop');
            const shopName = response.data.shopName;
            if (shopName) {
              localStorage.setItem('shopName', shopName);
              dispatch(setShop(shopName));
          } else {
            console.log('No auth token in cookies');
          }
        } catch (error) {
          console.error('Failed to fetch shop name:', error);
        }
      } else {
        dispatch(setShop(storedShopName));
      }
    };
    
    if(isAuthenticated){
      initializeShop();
      dispatch(fetchTodayRate());
    }

  }, [dispatch, isAuthenticated]);


  return (
      <BrowserRouter>
        <ShopDomainRedirect>
        <ActivityTracker />
        <Routes>
          <Route path="/login" element={
            <PublicRoute>
              <Login />
            </PublicRoute>
          }/>
          <Route path="/forgotpassword" element={
            <PublicRoute>
              <ForgotPassword/>
            </PublicRoute>
          }/>
          <Route path="/ordersummary" element={
            <PublicRoute>
              <OrderSummary/>
            </PublicRoute>
          }/>
          <Route path="/sendonly" element={
            <PublicRoute>
              <SendOnlyForm/>
            </PublicRoute>
          }/>
          <Route path="/liff/*" element={<LiffApp />} />
          <Route path="/upload-slip/:token" element={<RefundReceiptPage />} />
          <Route path="/void-check/:token" element={<VoidCheckPage />} />
          <Route path="/dispatch/proof" element={<DispatchProofPage />} />
          <Route path="/dispatch/me/:token" element={<DispatchBuyerPage />} />
          <Route path="/dispatch/me/:token/tracking" element={<DispatchTrackingPage />} />
          {routes.map(({ path, component }) => (
            <Route
              key={path}
              path={path}
              element={
                <ProtectedRoute element={
                  <Layout showRedBar={component === KeyData}>
                    <Sidebar>{React.createElement(component)}</Sidebar>
                  </Layout>}
                />
              }
            />
          ))}
        </Routes>
        </ShopDomainRedirect>
      </BrowserRouter>
  );
}

export default App;
